var map = {
	"./colors": 39,
	"./colors.js": 39,
	"./custom/trap": 108,
	"./custom/trap.js": 108,
	"./custom/zalgo": 109,
	"./custom/zalgo.js": 109,
	"./extendStringPrototype": 110,
	"./extendStringPrototype.js": 110,
	"./index": 171,
	"./index.js": 171,
	"./maps/america": 111,
	"./maps/america.js": 111,
	"./maps/rainbow": 112,
	"./maps/rainbow.js": 112,
	"./maps/random": 113,
	"./maps/random.js": 113,
	"./maps/zebra": 114,
	"./maps/zebra.js": 114,
	"./styles": 86,
	"./styles.js": 86,
	"./system/supports-colors": 115,
	"./system/supports-colors.js": 115
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 170;



/*****************
 ** WEBPACK FOOTER
 ** ./~/colors/lib ^\.\/.*$
 ** module id = 170
 ** module chunks = 0
 **/